export let Code = {
type: `@Component({
    selector: 'p-fileUpload',
    template:
        <p-growl [value]="msgs"></p-growl>
        <h3 class="first">Advanced</h3>
        <p-fileUpload name="demo[]" url="./upload.php" (onUpload)="onUpload($event)" 
                multiple="multiple" accept="image/*" maxFileSize="1000000">
            <ng-template pTemplate="content">
                <ul *ngIf="uploadedFiles.length">
                    <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                </ul>
            </ng-template>        
        </p-fileUpload>

})
export class FileUpload {

}
`,
Basictype: `@Component({
    selector: 'p-fileUpload',
    template:
        <p-fileUpload mode="basic" name="demo[]" url="./upload.php" accept="image/*" maxFileSize="1000000" (onUpload)="onBasicUpload($event)"></p-fileUpload>
})
export class FileUpload {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/fileupload.ts